import userApi from '@/apis/user/api';
import { useMutation } from '@tanstack/react-query';
import { IRequesterResponse } from '@/utils/requester';
import utils from '@/utils';

interface IOptionsUseUpdateUser {
  onMutate?: () => void;
  onError?: (error: Error, variables: any, context: unknown) => unknown;
  onSuccess?: (data: IRequesterResponse<any>, variables: any, context: unknown) => unknown;
}

const userService = {
  useUpdateUser: (options?: IOptionsUseUpdateUser) => {
    return useMutation({
      mutationFn: async (data: any) => {
        const response = await userApi.update(data);
        if (response?.error) {
          throw new Error(response.error?.message || 'Cập nhật thất bại');
        }
        return response;
      },
      onMutate: () => {
        utils.loading(true);
        options?.onMutate?.();
      },
      onSuccess: (data, variables, context) => {
        options?.onSuccess?.(data, variables, context);
        setTimeout(() => {
          utils.loading(false);
        }, 1000);
      },
      onError: (error, variables, context) => {
        options?.onError?.(error, variables, context);
        setTimeout(() => {
          utils.loading(false);
        }, 1000);
      },
    });
  },
};

export default userService;
